import { ConfigSettingsService } from '../config-settings/config-settings.service';
import { Injectable, inject } from '@angular/core';
import { TutorialEntry, TutorialEntryFeatured, TutorialFeature } from '../../models/Tutorial';

@Injectable()
export class TutorialService {
  private readonly configService = inject(ConfigSettingsService);

  public getTutorials(): TutorialEntryFeatured[] | undefined {
    const tutorialList = this.configService.appSettings.tutorial;
    if (!tutorialList) {
      return undefined;
    }
    return tutorialList.map((tutorial) =>
      'feature' in tutorial && tutorial.feature ? this.resolve(tutorial.feature) : tutorial,
    );
  }

  private getTutorialEntry(nr: number): TutorialEntry {
    return {
      image: `erfolg${nr}`,
      title: `tutorial.${nr}.title`,
      description: `tutorial.${nr}.description`,
      aria: { label: `a11y.tutorial.${nr}` },
    };
  }

  private resolve(feature: TutorialFeature): TutorialEntry {
    switch (feature) {
      case 'REGISTRIEREN_STEP1':
        return this.getTutorialEntry(1);
      case 'AKTIVIEREN_STEP2':
        return this.getTutorialEntry(2);
      case 'BRIEF_STEP3':
        return this.getTutorialEntry(3);
      case 'FREISCHALTEN_STEP4':
        return this.getTutorialEntry(4);
    }
  }
}
